import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

const survey = {
  fetchSurvey (key) {
    return axios.get(`${API_URL}/Surveys/find-by-key/${key}`)
  },

  fetchAverageVotesCount (questionId) {
    return axios.get(`${API_URL}/Questions/find-average-vote-count/${questionId}`)
  },

  incrementVotesCount (key, userVotes) {
    return axios.patch(`${API_URL}/Surveys/vote/${key}`, userVotes)
  }
}

export {
  survey
}
